import { util } from 'pevueglobal'
import { router } from '../../router'
import { store } from '@/store'
import { graphdata, getGraphUrl, setReportStatus, resetreportstatus, setGraphdata } from '../XVgraphcontrol.js'
import {
  setXVtableMutations,
  XVtableSetRowStateProperty,
  XVTablesort,
  XVtablecolumnsettingchanged,
  initXVtableState,
  addXVtableState
} from '../XVtableV2'
// dit wordt ook de store van de detailpagina
// state
const state = {
  msfTable: {
    tablesetting: {},
    tablecolumnsetting: [],
    tabledata: [],
    rowvisible: []
  },
  ReadMSFIndicatorVis: false,
  defaulttitleVis: false,
  pagesettings: [],
  personid: null,
  SPE697deelnemersTable: {
    tablesetting: {},
    tablecolumnsetting: [],
    tabledata: [],
    rowvisible: []
  },
  SPE697pagesettings: [],
  btnExportVis: false,
  tonenVis: false,
  msfDetailTable: {
    tablesetting: {},
    tablecolumnsetting: [],
    tabledata: [],
    rowvisible: []
  },
  dataloaded: false,
  showMutliLangTitle: false,
  showMultiLangDesc: false,
  disable: {
    disabledMultiLangTitle: false,
    disabledMultiLangDesc: false,
    disabledMultiLangMail: false,
    disabledEndDate: false,
    disabledStartDate: false,
    disabledBtnOk: false,
    disabledBtnExtend: false
  },
  inputfields: {
    iStartDate: null,
    iEndDate: null,
    multiLangTitletextID: [],
    multiLangDescriptiontextID: [],
    multiLangMailtextID: []
  },
  graphdata: [],
  standalone: false
}

// getters
const getters = {
  pagesettings: state => state.pagesettings,
  msfTable: state => state.msfTable,
  personid: state => state.personid,
  // SPE697
  SPE697pagesettings: state => state.SPE697pagesettings,
  msfDetailTable: state => state.msfDetailTable,
  dataloaded: state => state.dataloaded,
  showMutliLangTitle: state => state.showMutliLangTitle,
  showMultiLangDesc: state => state.showMultiLangDesc,
  disable: state => state.disable,
  graphdata: graphdata('graphdata'),
  standalone: state => state.standalone
}
// actions
const actions = {
  spe696getTexten: async ({ dispatch }) => {
    let textIDs = [17, 23, 150, 334, 3510, 3511, 3512, 6506, 6509, 6510, 6511, 9376, 9597, 10367, 12339, 14828, 14829]
    for (var i = 18909; i <= 18914; i++) {
      textIDs.push(i)
    }
    dispatch('gettranslations', textIDs, { root: true })
  },
  spe697getTexten: async ({ dispatch }) => {
    let textIDs = [
      17,
      23,
      786,
      6515,
      6516,
      6517,
      6520,
      6521,
      6524,
      6547,
      6552,
      6553,
      6555,
      6590,
      6640,
      6642,
      9157,
      9158,
      9597,
      10126,
      10439,
      10539,
      10580,
      10686,
      10687,
      10688,
      10689,
      10814,
      10815,
      10816,
      14642,
      15336,
      16147
    ]
    for (var i = 18915; i <= 18920; i++) {
      textIDs.push(i)
    }
    dispatch('gettranslations', textIDs, { root: true })
  },
  getGraphUrl: getGraphUrl('setReportStatus'),
  getPagesettings: async ({ commit, state }, personid) => {
    const data = await util.getDataApi('allroles/PEapi_SPE696_PatientEnquete_overview', {
      MSFtblpersonid: personid
    })
    if (data.ds.data0.length === 1) {
      commit('setPagesettings', data)
    }
    const xvData = await util.GetXVTableDataV2('allroles/PEapi_SPE696_PatientEnquete_overview_XVTable', {
      MSFtblpersonid: personid
    })
    commit('setMsfTableData', xvData)
    commit('setXVtablesetting')
    commit('setXVtableColumnsettings')
    commit('initXVtableState', state.msfTable)
    commit('setCustomColumnSettings')
  },
  deleteRow: async ({ commit, rootState }, selectedRowID) => {
    const output = await util.getDataApi('allroles/PEapi_TblMultiSourceFeedback_delete', {
      tblMultiSourceFeedbackID: selectedRowID
    })
    if (output.status === '200') {
      commit(
        'addNotification',
        {
          groupname: 'danger',
          message: rootState.translation[14829]
        },
        {
          root: true
        }
      )
      commit('deleteRow', selectedRowID)
    }
  },
  getSpe697PageSettings: async ({ commit, state }, msfpersonID) => {
    if (state.standalone === true) {
      store.commit('setMenuOptions', {
        loadTopbanner: false,
        loadLangChoice: false,
        loadMenu: false,
        loadFixedLinks: false
      })
    }
    const data = await util.getDataApi('allroles/PEapi_SPE697_PatientEnquete_detail', msfpersonID)
    if (data.status === '200') {
      commit('setSpe697PageSettings', data)
    }
    const xvData = await util.GetXVTableDataV2('allroles/PEapi_SPE697_PatientEnquete_detail_XVTable', msfpersonID)
    commit('setMsfDetailTableData', xvData)
    commit('setXVtablesettingDetail')
    commit('setXVtableColumnsettingsDetail')
    commit('setExportButton', state.msfDetailTable)
    commit('setTonenColumnSettings', state.msfDetailTable)
    commit('compInitXVtableState', state.msfDetailTable)
  },
  getSpe697GetGraphs: async ({ commit }, graphInput) => {
    const graphdata = await util.getDataApi('allroles/PEapi_GraphControl_Get_Available_Graphs', graphInput)
    if (graphdata.status === '200') {
      commit('setGraphdata', graphdata)
    }
  },
  updateMSF: async ({ commit, rootState, dispatch }, inputdata) => {
    const output = await util.getDataApi('allroles/PEapi_TblMultiSourceFeedback_update', inputdata)
    if (output.status === '200') {
      commit(
        'addNotification',
        {
          groupname: 'primary',
          message: rootState.translation[149]
        },
        {
          root: true
        }
      )
      if (inputdata.MSFtblpersonid === null) {
        router.push({
          name: 'SPE696PatientEnquete'
        })
      } else {
        router.push({
          name: 'SPE696PatientEnquete',
          params: {
            personid: inputdata.MSFtblpersonid
          }
        })
      }
    }
  },
  deleteMSF: async ({ commit, rootState }, inputdata) => {
    const output = await util.getDataApi('allroles/PEapi_TblMultiSourceFeedback_delete', {
      tblMultiSourceFeedbackID: inputdata
    })
    if (output.status === '200') {
      commit(
        'addNotification',
        {
          groupname: 'primary',
          message: rootState.translation[149]
        },
        {
          root: true
        }
      )
      if (state.personid === null) {
        router.push({
          name: 'SPE696PatientEnquete'
        })
      } else {
        router.push({
          name: 'SPE696PatientEnquete',
          params: {
            personid: state.personid
          }
        })
      }
    }
  }
}

// mutations
const mutations = {
  setReportStatus: setReportStatus('graphdata'),
  resetreportstatus: resetreportstatus('graphdata'),
  setGraphdata: setGraphdata('graphdata'),
  ...setXVtableMutations('msfTable'),
  // nodig voor xvtable spe697 omdat setXVtableMutations maar 1x gebruikt kan worden in store
  compXVtableSetRowStateProperty: XVtableSetRowStateProperty('msfDetailTable'),
  compXVTablesort: XVTablesort('msfDetailTable'),
  compXVtablecolumnsettingchanged: XVtablecolumnsettingchanged('msfDetailTable'),
  compInitXVtableState: initXVtableState('msfDetailTable'),
  compAddXVtableState: addXVtableState('msfDetailTable'),
  // einde xvtable spe697
  setPagesettings(state, myPagesettings) {
    state.pagesettings = myPagesettings.ds.data0[0]
  },
  setPersonid(state, personid) {
    state.personid = personid
  },
  deleteRow(state, selectedRowID) {
    state.msfTable.tabledata = state.msfTable.tabledata.filter(rij => rij.tblMultiSourceFeedbackID !== selectedRowID)
  },

  // setMsfDetailTable(state, data) {
  //   state.msfDetailTable.tablesetting = data.tablesetting
  //   state.msfDetailTable.tablecolumnsetting = data.tablecolumnsetting
  //   state.msfDetailTable.tabledata = data.tabledata
  // },
  setSpe697PageSettings(state, data) {
    if (data.ds.data0[0].redirect === null) {
      state.SPE697pagesettings = data.ds.data0[0]

      state.inputfields.iStartDate = new Date(state.SPE697pagesettings.tblMultiSourceFeedbackDateStart)
      state.inputfields.iEndDate = new Date(state.SPE697pagesettings.tblMultiSourceFeedbackDateEnd)
      state.inputfields.multiLangTitletextID = data.ds.data1.filter(
        d => d.tblTextUserID === data.ds.data0[0].titletextID
      )
      state.inputfields.multiLangTitletextID.forEach(e => {
        e.tblTextUserContents = e.tblTextUserContents.replace(/<br\s*\/?>/gm, '\n')
        if (state.showMutliLangTitle === false && e.tblTextUserContents !== '') {
          state.showMutliLangTitle = true
        }
        if (state.disable.disabledMultiLangTitle === false && e.tblTextUserContents !== '') {
          state.disable.disabledMultiLangTitle = true
        }
      })
      state.inputfields.multiLangDescriptiontextID = data.ds.data1.filter(
        d => d.tblTextUserID === data.ds.data0[0].descriptiotextID
      )
      state.inputfields.multiLangDescriptiontextID.forEach(e => {
        e.tblTextUserContents = e.tblTextUserContents.replace(/<br\s*\/?>/gm, '\n')
        if (state.showMultiLangDesc === false && e.tblTextUserContents !== '') {
          state.showMultiLangDesc = true
        }
        if (state.disable.disabledMultiLangDesc === false && e.tblTextUserContents !== '') {
          state.disable.disabledMultiLangDesc = true
        }
      })
      state.inputfields.multiLangMailtextID = data.ds.data1.filter(d => d.tblTextUserID === data.ds.data0[0].mailtextID)
      state.inputfields.multiLangMailtextID.forEach(e => {
        e.tblTextUserContents = e.tblTextUserContents.replace(/<br\s*\/?>/gm, '\n')
        if (state.disable.disabledMultiLangMail === false && e.tblTextUserContents !== '') {
          state.disable.disabledMultiLangMail = true
        }
      })
      if (state.SPE697pagesettings.status === 'open' || state.SPE697pagesettings.status === 'gesloten') {
        state.disable.disabledStartDate = true
      } else {
        state.disable.disabledStartDate = false
      }
      if (state.SPE697pagesettings.status === 'gesloten') {
        state.disable.disabledEndDate = true
      } else {
        // Issue 18098. If createname is filled, then the enddate must be disabled.
        if (state.SPE697pagesettings.CreateName === null) {
          state.disable.disabledEndDate = false
        } else {
          state.disable.disabledEndDate = true
        }
      }
      if (state.SPE697pagesettings.status === 'open' || state.SPE697pagesettings.status === 'notstarted') {
        // Issue 18098. If createname is filled, then the button 'OK' and mailtekst must be disabled.
        if (state.SPE697pagesettings.CreateName === null) {
          state.disable.disabledBtnOk = false
        } else {
          state.disable.disabledBtnOk = true
          state.disable.disabledMultiLangMail = true
        }
      } else {
        state.disable.disabledBtnOk = true
      }
      state.dataloaded = true
    }
  },
  setCustomColumnSettings(state) {
    state.msfTable.tabledata.forEach(datarow => {
      if (datarow.ReadMSF_Indicator === 2) {
        state.ReadMSFIndicatorVis = true
      }
      if (datarow.defaulttitle !== '') {
        state.defaulttitleVis = true
      }
    })
    if (state.ReadMSFIndicatorVis === true) {
      state.msfTable.tablecolumnsetting.forEach(row => {
        if (row.name === 'TblMSFverwijder') {
          row.visible = 1
        }
      })
    } else {
      state.msfTable.tablecolumnsetting.forEach(row => {
        if (row.name === 'TblMSFverwijder') {
          row.visible = 0
        }
      })
    }

    if (state.defaulttitleVis === true) {
      state.msfTable.tablecolumnsetting.forEach(row => {
        if (row.name === 'defaulttitle') {
          row.visible = 1
        }
      })
    } else {
      state.msfTable.tablecolumnsetting.forEach(row => {
        if (row.name === 'defaulttitle') {
          row.visible = 0
        }
      })
    }
  },
  setExportButton(state, table) {
    table.tabledata.forEach(datarow => {
      if (datarow.export !== null) {
        state.btnExportVis = true
      }
    })
    if (state.btnExportVis === true) {
      state.msfDetailTable.tablecolumnsetting.forEach(row => {
        if (row.name === 'export') {
          row.visible = 1
        }
      })
    } else {
      state.msfDetailTable.tablecolumnsetting.forEach(row => {
        if (row.name === 'export') {
          row.visible = 0
        }
      })
    }
  },
  setTonenColumnSettings(state, table) {
    table.tabledata.forEach(datarow => {
      if (datarow.tonen !== null) {
        state.tonenVis = true
      }
    })
    if (state.tonenVis === true) {
      state.msfDetailTable.tablecolumnsetting.forEach(row => {
        if (row.name === 'tonen') {
          row.visible = 1
        }
      })
    } else {
      state.msfDetailTable.tablecolumnsetting.forEach(row => {
        if (row.name === 'tonen') {
          row.visible = 0
        }
      })
    }
  },
  toggleExtend(state) {
    state.disable.disabledEndDate = !state.disable.disabledEndDate
    state.disable.disabledBtnOk = !state.disable.disabledBtnOk
    state.disable.disabledBtnExtend = !state.disable.disabledBtnExtend
  },
  setStandalone(state, sa) {
    state.standalone = sa === 1
  },
  setMsfTableData(state, data) {
    state.msfTable.tabledata = data.tabledata
  },
  setXVtablesetting(state) {
    state.msfTable.tablsetting = {
      procedure: 'PEapi_SPE696_PatientEnquete_overview_XVTable',
      tableName: 'msfTable',
      sequence: 1,
      sortable: 1,
      paging: 1,
      pagingSize: 50,
      alwaysShowDetail: null
    }
  },
  setXVtableColumnsettings(state) {
    state.msfTable.tablecolumnsetting = [
      {
        procedure: 'PEapi_SPE696_PatientEnquete_overview_XVTable',
        tableName: 'msfTable',
        name: 'tblMSFverwijder',
        sequence: 1,
        sortable: 0,
        sortableDefault: 0,
        visible: 1,
        headerTextID: 0,
        visibleXS: 0,
        visibleSM: 0,
        visibleMD: 1,
        type: 'string',
        sortColumn: null,
        widthXS: null,
        widthSM: '30px',
        widthMD: '30px',
        helpTextID: null,
        columnname: ''
      },
      {
        procedure: 'PEapi_SPE696_PatientEnquete_overview_XVTable',
        tableName: 'msfTable',
        name: 'tblMultiSourceFeedbackDateCreated',
        sequence: 2,
        sortable: 1,
        sortableDefault: 0,
        visible: 1,
        headerTextID: 6507,
        visibleXS: 1,
        visibleSM: 1,
        visibleMD: 1,
        type: 'date',
        sortColumn: 'sortdate',
        widthXS: '100px',
        widthSM: '100px',
        widthMD: '100px',
        helpTextID: null,
        columnname: store.getters.translation(18909) // 'Datum'
      },
      {
        procedure: 'PEapi_SPE696_PatientEnquete_overview_XVTable',
        tableName: 'msfTable',
        name: 'defaulttitle',
        sequence: 3,
        sortable: 1,
        sortableDefault: 0,
        visible: 1,
        headerTextID: 10686,
        visibleXS: 1,
        visibleSM: 1,
        visibleMD: 1,
        type: 'string',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: store.getters.translation(18910) // 'Titel'
      },
      {
        procedure: 'PEapi_SPE696_PatientEnquete_overview_XVTable',
        tableName: 'msfTable',
        name: 'tblMultiSourceFeedbackDateStart',
        sequence: 4,
        sortable: 0,
        sortableDefault: 0,
        visible: 1,
        headerTextID: 6509,
        visibleXS: 0,
        visibleSM: 0,
        visibleMD: 1,
        type: 'date',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: '100px',
        helpTextID: null,
        columnname: store.getters.translation(18911) // 'Start'
      },
      {
        procedure: 'PEapi_SPE696_PatientEnquete_overview_XVTable',
        tableName: 'msfTable',
        name: 'tblMultiSourceFeedbackDateEnd',
        sequence: 5,
        sortable: 0,
        sortableDefault: 0,
        visible: 1,
        headerTextID: 6510,
        visibleXS: 0,
        visibleSM: 0,
        visibleMD: 1,
        type: 'date',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: '100px',
        helpTextID: null,
        columnname: store.getters.translation(18912) // 'Einde'
      },
      {
        procedure: 'PEapi_SPE696_PatientEnquete_overview_XVTable',
        tableName: 'msfTable',
        name: 'formSetName',
        sequence: 6,
        sortable: 1,
        sortableDefault: 0,
        visible: 1,
        headerTextID: 9376,
        visibleXS: 0,
        visibleSM: 0,
        visibleMD: 1,
        type: 'string',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: store.getters.translation(18913) // 'Naam'
      },
      {
        procedure: 'PEapi_SPE696_PatientEnquete_overview_XVTable',
        tableName: 'msfTable',
        name: 'status',
        sequence: 7,
        sortable: 1,
        sortableDefault: 0,
        visible: 1,
        headerTextID: 6511,
        visibleXS: 0,
        visibleSM: 1,
        visibleMD: 1,
        type: 'string',
        sortColumn: null,
        widthXS: null,
        widthSM: '100px',
        widthMD: '100px',
        helpTextID: null,
        columnname: store.getters.translation(18914) // 'status'
      },
      {
        procedure: 'PEapi_SPE696_PatientEnquete_overview_XVTable',
        tableName: 'msfTable',
        name: 'tblMultiSourceFeedbackIDLink',
        sequence: 8,
        sortable: 0,
        sortableDefault: 0,
        visible: 0,
        headerTextID: null,
        visibleXS: null,
        visibleSM: null,
        visibleMD: null,
        type: 'string',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: 'Text not defined'
      },
      {
        procedure: 'PEapi_SPE696_PatientEnquete_overview_XVTable',
        tableName: 'msfTable',
        name: 'tblMultiSourceFeedbackID',
        sequence: 9,
        sortable: 0,
        sortableDefault: 0,
        visible: 0,
        headerTextID: null,
        visibleXS: null,
        visibleSM: null,
        visibleMD: null,
        type: 'string',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: 'Text not defined'
      },
      {
        columnname: 'tableRowState',
        name: 'tableRowState',
        headerTextID: null,
        sequence: 10,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        type: null,
        visible: 0,
        visibleMD: null,
        visibleSM: null,
        visibleXS: null,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'msfTable',
        procedure: '',
        helpTextID: null
      }
    ]
  },
  setMsfDetailTableData(state, data) {
    state.msfDetailTable.tabledata = data.tabledata
  },
  setXVtablesettingDetail(state) {
    state.msfDetailTable.tablesetting = {
      procedure: 'PEapi_SPE697_PatientEnquete_detail_XVTable',
      tableName: 'msfDetailTable',
      sequence: 1,
      sortable: 1,
      paging: 1,
      pagingSize: 50,
      alwaysShowDetail: null
    }
  },
  setXVtableColumnsettingsDetail(state) {
    state.msfDetailTable.tablecolumnsetting = [
      {
        procedure: 'PEapi_SPE697_PatientEnquete_detail_XVTable',
        tableName: 'msfDetailTable',
        name: 'tblMultiSourceFeedbackPersonID',
        sequence: 1,
        sortable: 0,
        sortableDefault: 0,
        visible: 0,
        headerTextID: 0,
        visibleXS: 0,
        visibleSM: 0,
        visibleMD: 0,
        type: 'number',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: ''
      },
      {
        procedure: 'PEapi_SPE697_PatientEnquete_detail_XVTable',
        tableName: 'msfDetailTable',
        name: 'tblMultiSourceFeedbackID',
        sequence: 2,
        sortable: 0,
        sortableDefault: 0,
        visible: 0,
        headerTextID: 0,
        visibleXS: 0,
        visibleSM: 0,
        visibleMD: 0,
        type: 'number',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: ''
      },
      {
        procedure: 'PEapi_SPE697_PatientEnquete_detail_XVTable',
        tableName: 'msfDetailTable',
        name: 'tblMultiSourceFeedbackPersonDateFilled',
        sequence: 3,
        sortable: 1,
        sortableDefault: 0,
        visible: 1,
        headerTextID: 6526,
        visibleXS: 0,
        visibleSM: 0,
        visibleMD: 1,
        type: 'date',
        sortColumn: null,
        widthXS: '140px',
        widthSM: '140px',
        widthMD: '140px',
        helpTextID: null,
        columnname: store.getters.translation(18915) // 'Datum voltooid'
      },
      {
        procedure: 'PEapi_SPE697_PatientEnquete_detail_XVTable',
        tableName: 'msfDetailTable',
        name: 'tblMultiSourceFeedbackPersonDateCreated',
        sequence: 4,
        sortable: 1,
        sortableDefault: 0,
        visible: 1,
        headerTextID: 6527,
        visibleXS: 0,
        visibleSM: 1,
        visibleMD: 1,
        type: 'date',
        sortColumn: null,
        widthXS: '140px',
        widthSM: '140px',
        widthMD: '140px',
        helpTextID: null,
        columnname: store.getters.translation(18916) // 'Datum toegevoegd'
      },
      {
        procedure: 'PEapi_SPE697_PatientEnquete_detail_XVTable',
        tableName: 'msfDetailTable',
        name: 'tblMultiSourceFeedbackPersonName',
        sequence: 5,
        sortable: 1,
        sortableDefault: 1,
        visible: 1,
        headerTextID: 6528,
        visibleXS: 1,
        visibleSM: 1,
        visibleMD: 1,
        type: 'string',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: store.getters.translation(18917) // 'Naam persoon'
      },
      {
        procedure: 'PEapi_SPE697_PatientEnquete_detail_XVTable',
        tableName: 'msfDetailTable',
        name: 'tblMultiSourceFeedbackPersonEmail',
        sequence: 6,
        sortable: 1,
        sortableDefault: 0,
        visible: 1,
        headerTextID: 6530,
        visibleXS: 0,
        visibleSM: 0,
        visibleMD: 1,
        type: 'string',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: store.getters.translation(18918) // 'E-mail'
      },
      {
        procedure: 'PEapi_SPE697_PatientEnquete_detail_XVTable',
        tableName: 'msfDetailTable',
        name: 'tblMultiSourceFeedbackPersonguid',
        sequence: 7,
        sortable: 0,
        sortableDefault: 0,
        visible: 0,
        headerTextID: 0,
        visibleXS: 0,
        visibleSM: 0,
        visibleMD: 0,
        type: 'string',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: ''
      },
      {
        procedure: 'PEapi_SPE697_PatientEnquete_detail_XVTable',
        tableName: 'msfDetailTable',
        name: 'tblEvaluationFormID',
        sequence: 8,
        sortable: 0,
        sortableDefault: 0,
        visible: 0,
        headerTextID: 0,
        visibleXS: 0,
        visibleSM: 0,
        visibleMD: 0,
        type: 'number',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: ''
      },
      {
        procedure: 'PEapi_SPE697_PatientEnquete_detail_XVTable',
        tableName: 'msfDetailTable',
        name: 'rolname',
        sequence: 9,
        sortable: 1,
        sortableDefault: 0,
        visible: 1,
        headerTextID: 6529,
        visibleXS: 0,
        visibleSM: 0,
        visibleMD: 1,
        type: 'string',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: '90px',
        helpTextID: null,
        columnname: store.getters.translation(18919) // 'Rol'
      },
      {
        procedure: 'PEapi_SPE697_PatientEnquete_detail_XVTable',
        tableName: 'msfDetailTable',
        name: 'tblTypeFormID',
        sequence: 10,
        sortable: 0,
        sortableDefault: 0,
        visible: 0,
        headerTextID: 0,
        visibleXS: 0,
        visibleSM: 0,
        visibleMD: 0,
        type: 'number',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: ''
      },
      {
        procedure: 'PEapi_SPE697_PatientEnquete_detail_XVTable',
        tableName: 'msfDetailTable',
        name: 'formname',
        sequence: 11,
        sortable: 1,
        sortableDefault: 0,
        visible: 1,
        headerTextID: 6508,
        visibleXS: 1,
        visibleSM: 1,
        visibleMD: 1,
        type: 'string',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: store.getters.translation(18920) // 'Formulier'
      },
      {
        procedure: 'PEapi_SPE697_PatientEnquete_detail_XVTable',
        tableName: 'msfDetailTable',
        name: 'showbutton',
        sequence: 12,
        sortable: 0,
        sortableDefault: 0,
        visible: 0,
        headerTextID: 0,
        visibleXS: 0,
        visibleSM: 0,
        visibleMD: 0,
        type: 'number',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: ''
      },
      {
        procedure: 'PEapi_SPE697_PatientEnquete_detail_XVTable',
        tableName: 'msfDetailTable',
        name: 'datefilled',
        sequence: 13,
        sortable: 0,
        sortableDefault: 0,
        visible: 0,
        headerTextID: 0,
        visibleXS: 0,
        visibleSM: 0,
        visibleMD: 0,
        type: 'string',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: ''
      },
      {
        procedure: 'PEapi_SPE697_PatientEnquete_detail_XVTable',
        tableName: 'msfDetailTable',
        name: 'tonen',
        sequence: 14,
        sortable: 0,
        sortableDefault: 0,
        visible: 0,
        headerTextID: 0,
        visibleXS: 0,
        visibleSM: 0,
        visibleMD: 1,
        type: 'string',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: '90px',
        helpTextID: null,
        columnname: ''
      },
      {
        procedure: 'PEapi_SPE697_PatientEnquete_detail_XVTable',
        tableName: 'msfDetailTable',
        name: 'export',
        sequence: 15,
        sortable: 0,
        sortableDefault: 0,
        visible: 0,
        headerTextID: 0,
        visibleXS: 0,
        visibleSM: 0,
        visibleMD: 1,
        type: 'string',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: '90px',
        helpTextID: null,
        columnname: ''
      },
      {
        columnname: 'tableRowState',
        name: 'tableRowState',
        headerTextID: null,
        sequence: 16,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        type: null,
        visible: 0,
        visibleMD: null,
        visibleSM: null,
        visibleXS: null,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'msfDetailTable',
        procedure: '',
        helpTextID: null
      }
    ]
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
